export const LocalStorageConstant = {
    AMZWARE_TOKEN: 'AMZWARE_TOKEN',
}